var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

import { fromUnixTime, format, addMinutes } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { minZero } from "./math";
import { DAYS, DAYS_SHORT } from "../constants/date";
import { AM, PM, TIMEZONES, TIMEZONES_DST } from "../constants/time";
import { DELIVERY } from "../constants/order";
export var formatHour = function formatHour(hour) {
  return hour.trim().substring(0, 5);
};
export var toCivilianTime = function toCivilianTime(time) {
  var _a = time.split(":").map(function (i) {
    return parseInt(i, 10);
  }),
      hour = _a[0],
      minute = _a[1];

  if (hour >= 24) hour %= 24;
  if (minute >= 60) minute %= 60;
  var suffix = hour >= 12 ? PM : AM;
  return "".concat((hour + 11) % 12 + 1, ":").concat(minute.toString().padStart(2, "0"), " ").concat(suffix);
};
export var toDayOfWeek = function toDayOfWeek(number, isShort) {
  if (isShort === void 0) {
    isShort = false;
  }

  return (isShort ? DAYS_SHORT : DAYS)[minZero(minZero(number) % 7)];
};
export var getFlankDays = function getFlankDays(k) {
  if (k === void 0) {
    k = [];
  }

  if (k.length > 1) {
    return [toDayOfWeek(k[0]), toDayOfWeek(k[k.length - 1])].join("-");
  }

  return toDayOfWeek(k[0]);
};
export var sortAndSplitHours = function sortAndSplitHours(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var splitBySequence = function splitBySequence(items, differences) {
    if (items === void 0) {
      items = [];
    }

    if (differences === void 0) {
      differences = [];
    }

    return items.reduce(function (memo, item) {
      var lastArray = memo[memo.length - 1];
      var lastItem = lastArray[lastArray.length - 1];

      if (!lastItem || differences.includes(item - lastItem)) {
        lastArray.push(item);
      } else {
        memo.push([item]);
      }

      return memo;
    }, [[]]);
  };

  var x = Object.entries(obj).reduce(function (accu, i) {
    var daysInSequence = splitBySequence(i[1], [1, -6]);
    return __spreadArray(__spreadArray([], accu, true), daysInSequence.map(function (y) {
      return {
        days: y,
        hours: i[0],
        order: y[0] ? y[0] : 7,
        text: getFlankDays(y)
      };
    }), true);
  }, []).sort(function (a, b) {
    return a.order - b.order;
  });
  return x;
};
export var combineHours = function combineHours(hours) {
  var hoursObject = hours.reduce(function (accu, i) {
    var hoursObj = accu;

    if (!i.deliveryOpen && !i.deliveryClose) {
      hoursObj.delivery.Closed = __spreadArray(__spreadArray([], hoursObj.delivery.Closed || [], true), [i.day], false);
    } else {
      var deliveryOpen = toCivilianTime(formatHour(i.deliveryOpen));
      var deliveryClose = toCivilianTime(formatHour(i.deliveryClose));

      if (hoursObj.delivery["".concat(deliveryOpen, " - ").concat(deliveryClose)]) {
        hoursObj.delivery["".concat(deliveryOpen, " - ").concat(deliveryClose)].push(i.day);
      } else {
        hoursObj.delivery["".concat(deliveryOpen, " - ").concat(deliveryClose)] = [i.day];
      }
    }

    if (!i.pickupOpen && !i.pickupClose) {
      hoursObj.pickup.Closed = __spreadArray(__spreadArray([], hoursObj.pickup.Closed || [], true), [i.day], false);
    } else {
      var pickupOpen = toCivilianTime(formatHour(i.pickupOpen));
      var pickupClose = toCivilianTime(formatHour(i.pickupClose));

      if (hoursObj.pickup["".concat(pickupOpen, " - ").concat(pickupClose)]) {
        hoursObj.pickup["".concat(pickupOpen, " - ").concat(pickupClose)].push(i.day);
      } else {
        hoursObj.pickup["".concat(pickupOpen, " - ").concat(pickupClose)] = [i.day];
      }
    }

    if (!i.dineInOpen && !i.dineInClose) {
      hoursObj.kiosk.Closed = __spreadArray(__spreadArray([], hoursObj.kiosk.Closed || [], true), [i.day], false);
    } else {
      var dineInOpen = toCivilianTime(formatHour(i.dineInOpen));
      var dineInClose = toCivilianTime(formatHour(i.dineInClose));

      if (hoursObj.kiosk["".concat(dineInOpen, " - ").concat(dineInClose)]) {
        hoursObj.kiosk["".concat(dineInOpen, " - ").concat(dineInClose)].push(i.day);
      } else {
        hoursObj.kiosk["".concat(dineInOpen, " - ").concat(dineInClose)] = [i.day];
      }
    }

    return {
      delivery: __assign(__assign({}, accu.delivery), hoursObj.delivery),
      kiosk: __assign(__assign({}, accu.kiosk), hoursObj.kiosk),
      pickup: __assign(__assign({}, accu.pickup), hoursObj.pickup)
    };
  }, {
    delivery: {},
    kiosk: {},
    pickup: {}
  });
  return {
    delivery: sortAndSplitHours(hoursObject.delivery),
    kiosk: sortAndSplitHours(hoursObject.kiosk),
    pickup: sortAndSplitHours(hoursObject.pickup)
  };
};
export var combineValues = function combineValues(_a, orderType) {
  var _b = _a.delivery,
      delivery = _b === void 0 ? 0 : _b,
      _c = _a.prep,
      prep = _c === void 0 ? 0 : _c,
      _d = _a.pickup,
      pickup = _d === void 0 ? 0 : _d;
  var safePickup = pickup;
  var safeDelivery = delivery;
  var safePrep = prep;
  var baseValue = orderType === DELIVERY ? safeDelivery : safePickup;
  return safePrep + baseValue;
};
export var formatTime = function formatTime(min) {
  if (min === 0) {
    return "0 minutes";
  }

  var hours = min ? Math.floor(min / 60) : 0;
  var minutes = min ? min % 60 : 0;
  var values = [];

  if (hours) {
    values.push("".concat(hours, " hour").concat(hours > 1 ? "s" : ""));
  }

  if (minutes) {
    values.push("".concat(minutes, " minute").concat(minutes > 1 ? "s" : ""));
  }

  return values.join(" and ");
};
export var stdTimezoneOffset = function stdTimezoneOffset() {
  var baseDate = new Date();
  var jan = new Date(baseDate.getFullYear(), 0, 1);
  var jul = new Date(baseDate.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};
export var IS_DST_OBSERVED = new Date().getTimezoneOffset() < stdTimezoneOffset();
export var mapTimeZone = function mapTimeZone(timeZone, isDstObserved) {
  if (isDstObserved === void 0) {
    isDstObserved = IS_DST_OBSERVED;
  }

  var timeZoneMapping = isDstObserved ? TIMEZONES_DST : TIMEZONES;
  return timeZoneMapping[timeZone] || "";
};
export var displayScheduledAtTime = function displayScheduledAtTime(i, timeZone) {
  var timeStart = fromUnixTime(i);
  var zoneTime = utcToZonedTime(timeStart, timeZone);
  return format(zoneTime, "h:mm a");
};
export var displayScheduledAtTimeDelivery = function displayScheduledAtTimeDelivery(i, timeZone) {
  var timeStart = fromUnixTime(i);
  var timeEnd = addMinutes(timeStart, 15);
  return "".concat(format(utcToZonedTime(timeStart, timeZone), "h:mm a"), " - ").concat(format(utcToZonedTime(timeEnd, timeZone), "h:mm a"));
};
export var hoursToMs = function hoursToMs(hours) {
  return hours * 60 * 60 * 1000;
}; // TODO: Automatically countdown from 24

export var hours = {
  24: hoursToMs(24)
};